/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, August 24th 2022, 4:55:39 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Organization, OrganizationListItem } from "lib/schemas";
import { DeactivatedIcon } from "theme/icons";
import { OSActionButton, FullScreenNotificationGrid } from "ui-widgets";
import { OrganizationStatusChange } from "./OrganizationStatusChange";

export const DeactivatedOrganizationAlert = ({
  organization,
}: {
  organization: OrganizationListItem | Organization;
}) => (
  <FullScreenNotificationGrid
    pageTitle={`${organization.name} is currently deactivated.`}
    pageContent={
      <>
        <p>You can reactivate it by clicking the button below.</p>
        <p>
          <OrganizationStatusChange item={organization}>
            {({ onClick }) => (
              <OSActionButton variant="contained" onClick={onClick} size="large">
                Activate {organization.name}
              </OSActionButton>
            )}
          </OrganizationStatusChange>
        </p>
      </>
    }
    pageIllustration={<DeactivatedIcon height={256} width={256} />}
  />
);
